module.exports = __webpack_public_path__ + "img/banner.3f4ddec9.png";